<script>
  import SideNavHeaderLogo from "lib/components/layout/sideNav/SideNavHeaderLogo.svelte";
  import LoginModule from "lib/components/modules/authentication/LoginModule.svelte";
  import { onMount } from "svelte";
  /**
   * @type {HTMLElement}
   */
  let sideBarElement;
  onMount(() => {
    sideBarElement = document.getElementById("sidebar-left");
    if (!sideBarElement) return;
    sideBarElement.classList.add("login-side-nav__sidebar-left");
    return () => {
      if (!sideBarElement) return;
      sideBarElement.classList.remove("login-side-nav__sidebar-left");
    };
  });
</script>

<div class="login-side-nav">
  <div class="login-side-nav__container">
    <div class="login-side-logo">
      <SideNavHeaderLogo full />
    </div>
  </div>
  <div class="login-form-container">
    <LoginModule />
  </div>
</div>

<style>
  :global(.login-side-nav__sidebar-left) {
    --login-side-nav-width: clamp(24rem, 22vw, 28rem);
    background: var(--pax-white);
    z-index: var(--z20);
    width: var(--login-side-nav-width);
  }
  .login-side-nav {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .login-side-nav__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: var(--app-header-height);
    box-sizing: border-box;
    border-bottom: solid var(--bw) var(--border-color);
  }
  .login-side-logo {
    max-height: 3rem;
    max-width: 4.5rem;
    margin-left: var(--left-gap);
  }

  .login-form-container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    width: 100%;
  }
</style>
